export default __webpack_public_path__ + "static/media/exit.3d6ed20d.png";